export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9614.e38bde16.jpg";